// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"FullPizza","810":"NotFound","965":"Cart"}[chunkId] + "." + {"102":"c3c0542e","810":"81ee4c89","965":"16b10c1e"}[chunkId] + ".chunk.js";
};